module.exports = __webpack_public_path__ + "static/img/B1.f0bdd1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl/B1.png
// module id = nQpP
// module chunks = 0